import type { VehicleWriteRequest } from '@/api/generated/schemas';
import type { VehicleFormValues } from './vehicleFormSchema';

function emptyToNull(value: string): string | null {
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

function toNumber(value: string): number {
  return Number(value.trim());
}

function toOptionalNumber(value: string): number | null {
  return value.trim() === '' ? null : Number(value.trim());
}

/**
 * Mapuje hodnoty formuláře na společné API tělo zápisu vozu (create i update mají stejný tvar).
 * Pořadí `preferredDrivers` je významné — backend z indexu odvodí `Poradi`.
 */
export function toVehicleRequestBody(values: VehicleFormValues): VehicleWriteRequest {
  return {
    name: values.name.trim(),
    plate: values.plate.trim(),
    ownerOrganizationPartyId: values.owner?.partyId ?? 0,
    vehicleCategoryCbId: values.category?.id ?? 0,
    vehicleGroupCbId: values.group?.id ?? 0,
    vehicleManufacturerCbId: values.manufacturer?.id ?? 0,
    yearOfManufacture: toOptionalNumber(values.yearOfManufacture),
    initialMileageKm: toOptionalNumber(values.initialMileageKm),
    fuelType: values.fuelType,
    vin: emptyToNull(values.vin),
    passengerSeats: toNumber(values.passengerSeats),
    // Místa pro průvodce jsou volitelná — nevyplněno znamená nula (legacy sloupec je non-null).
    tourLeaderSeats: toOptionalNumber(values.tourLeaderSeats) ?? 0,
    displayOnResSheetWithRidesOnly: values.displayOnResSheetWithRidesOnly,
    commissioningDate: values.commissioningDate,
    retirementDate: values.retirementDate,
    insuranceExpiry: values.insuranceExpiry,
    inspectionExpiry: values.inspectionExpiry,
    tachographInspectionExpiry: values.tachographInspectionExpiry,
    preferredDriverIds: values.preferredDrivers.map((driver) => driver.workPersonFacilityId),
  } satisfies VehicleWriteRequest;
}
